import { SVGAttributes } from 'react'

export default function LinesRight(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} width="203" height="93" viewBox="0 0 203 93" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M271.147 74.5944C234.814 70.1202 197.787 66.109 160.528 62.7919" stroke="#79C2BE" strokeWidth="12" strokeMiterlimit="10" strokeLinecap="round"/>
			<path d="M216.094 25.1545C147.825 17.8262 77.8594 12.4264 8.74202 10.1894" stroke="#8DC63F" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round"/>
			<path d="M330.699 49.601C249.933 39.1099 166.468 30.2388 82.4626 23.9133" stroke="#6BAF45" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round" style={{ mixBlendMode: 'multiply' }}/>
		</svg>
	)
}
